/* eslint no-nested-ternary: "off" */

import React, { Component } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { setDimensionsWithSelectableValues } from "../../store/dimensions/dimensionsSlice";

import getSelectableValues from "../../helpers/getSelectableValues";

import Configurator from "./Configurator";
import LfcEngine from "./../../lfcengine/LfcEngine";
import calculateM2 from "./../../helpers/calculateM2";

class LfcCore extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lfcEngine: null,
      language: this.parseLanguageCode(this.props.language),
      channelId: this.props.channelId,
      dimensions: null,
      constraints: null,
      selectedValues: null,
      correctionInformation: [
        {
          dimensionId: null,
          constraint: null
        }
      ],
      generalError: false,
    };

    this.getDimensions = this.getDimensions.bind(this);
    this.setDimensions = this.setDimensions.bind(this);
    this.setSelectedValues = this.setSelectedValues.bind(this);
    this.getConstraints = this.getConstraints.bind(this);
    this.setConstraints = this.setConstraints.bind(this);
    this.getDimensionCode = this.getDimensionCode.bind(this);
    this.getDimensionName = this.getDimensionName.bind(this);
    this.getDimensionProperty = this.getDimensionProperty.bind(this);
    this.getMarketCode = this.getMarketCode.bind(this);
    this.getValueCode = this.getValueCode.bind(this);
    this.getValueName = this.getValueName.bind(this);
    this.getValueProperty = this.getValueProperty.bind(this);
    this.getSelectableValues = getSelectableValues.bind(this);
    this.getPackageSummary = this.getPackageSummary.bind(this);
    this.handleConfigResult = this.handleConfigResult.bind(this);
    this.handlePackageSummary = this.handlePackageSummary.bind(this);
    this.parseLanguageCode = this.parseLanguageCode.bind(this);
    this.comStatusUpdate = this.comStatusUpdate.bind(this);
    this.checkSelectedValues = this.checkSelectedValues.bind(this);
  }

  componentDidMount() {
    this.setState({
      lfcEngine: new LfcEngine( // TODO: flytta ut från state?
        this.props.context,
        this.props.priceHelper,
        this.props.pricingInfo,
        this.comStatusUpdate,
        this.props.env,
        this.props.lfcMode
      )
    });
  }

  // setDimensionsWithSelectableValues is set based on the state and therefore needs to be set when component updates
  // hence it cannot be used instead of passing dimensions prop
  componentDidUpdate() {
    if (this.state.dimensions?.dimensions && this.state.constraints) {
      this.props.setDimensionsWithSelectableValues(this.getSelectableValues(this.state.dimensions.dimensions, this.state.constraints));
    }
  }

  getDimensions() {
    return this.state.lfcEngine.getDimensions();
  }

  setDimensions(dimensions) {
    this.setState({
      dimensions
    });
  }

  setSelectedValues(selectedValues) {
    this.setState({
      selectedValues
    });
  }

  getConstraints(selectedValues) {
    return this.state.lfcEngine.checkConstraint(selectedValues);
  }

  setConstraints(constraints) {
    this.setState({
      constraints
    });
  }

  getDimensionCode(valueId) {
    return this.getDimensionProperty(valueId, "dimensionCode");
  }

  getDimensionName(valueId) {
    return this.getDimensionProperty(
      valueId,
      "dimensionName",
      this.state.language
    );
  }

  getDimensionProperty(valueId, propertyType, language) {
    if (this.state.dimensions?.dimensions && valueId) {
      return this.state.dimensions.dimensions.find(dimension =>
        dimension.values.find(value => value.valueId === valueId)
      )[`${propertyType}${language ? language : ""}`];
    }
    return null;
  }

  getMarketCode(channelId) {
    switch(channelId.toString()) {
      case "1":
        return "SE-SKBV";
      case "2":
        return "SE-BYME"
      case "4":
        return "NO-GF"
      case "7":
      case "8":
        return "FI-NR"
      case "9":
        return "NO-BYME"
      default:
        return "SE-SKBV";
    };
  }

  getValueCode(valueId) {
    return this.getValueProperty(valueId, "valueCode");
  }

  getValueName(valueId) {
    return this.getValueProperty(valueId, "valueName", this.state.language);
  }

  getValueProperty(valueId, propertyType, language) {
    if (this.state.dimensions?.dimensions && valueId) {
      const foundDimension = this.state.dimensions.dimensions.find(dimension =>
        dimension.values.find(value => value.valueId === valueId)
      );
      if (foundDimension) {
        const foundValue = foundDimension.values.find(
          value => value.valueId === valueId
        );
        return foundValue[`${propertyType}${language ? language : ""}`];
      }
      return null;
    }
    return null;
  }

  

  getPackageSummary() {
    this.props.updateInProgress(true); // TODO ska denna tas bort?

    if ((this.props.lfcMode === "WDW" || this.props.lfcMode === "DOOR")) {
      this.state.lfcEngine.getConfigResult(
        this.handleConfigResult,
        this.state.selectedValues,
        this.getMarketCode(this.state.channelId)
      );
    } else {
      this.state.lfcEngine.getSkuForParts(
        this.handlePackageSummary,
        this.state.selectedValues
      );
    }
  }

  handleConfigResult(configResult, selectedValues) {
    const properties = null;

    this.props.onChange(configResult, properties, selectedValues);
  }

  handlePackageSummary(bundle, metaInfo) {
    const { selectedValues } = this.state;

    const m2 = calculateM2(
      selectedValues,
      this.getDimensionCode,
      this.getValueCode
    );

    const properties = {
      m2,
      metaInfo
    };

    this.props.onChange(bundle, properties, selectedValues);
  }

  // Used to parse ISO 639-1 in props to LFC language when the initial state is setup
  parseLanguageCode(isoCode) {
    if (isoCode === "sv") {
      return "SE";
    }
    if (isoCode === "no") {
      return "NO";
    }
    if (isoCode === "fi") {
      return "FI";
    }
    if (isoCode === "en") {
      return "EN";
    }
    return isoCode;
  }

  comStatusUpdate(json) {
    if (
      (json.context.status !== 0 && json.context.status !== 200) ||
      (json.dimension.status !== 0 && json.dimension.status !== 200) ||
      (json.constraints.status !== 0 && json.constraints.status !== 200) ||
      (json.prices.status !== 0 && json.prices.status !== 200)
    ) {
      this.setState(
        {
          generalError: true
        },
        () => {
          this.props.onError({
            type: "generalError",
            contextStatus: json.context.status,
            dimensionsStatus: json.dimension.status,
            constraintsStatus: json.constraints.status,
            pricesStatus: json.prices.status
          });
        }
      );
    } else if (
      json.dimension.status === 200 &&
      json.constraints.status === 200 &&
      this.state.dimensions !== this.getDimensions()
    ) {
      this.setDimensions(this.getDimensions());
      this.setSelectedValues(this.props.defaultValues);
      // TODO: EV. ska detta flyttas ner...?
      this.setConstraints(this.getConstraints(this.state.selectedValues));
      this.getPackageSummary();
    }
  }

  checkSelectedValues(selectedValues) {
    const newConstraints = this.getConstraints(selectedValues);
    const notOkValues = selectedValues.filter(selectedValue =>
      newConstraints.find(
        constraint =>
          constraint.valueId === selectedValue &&
          (constraint.checkStatus === "DENYFOR" ||
            constraint.checkStatus === "NEEDSANYOF")
      )
    );
    if (notOkValues.length > 0) {
      const correctionInformation = notOkValues.map(notOkValue => ({
        dimensionId: this.state.dimensions?.dimensions.find(dimension =>
          dimension.values.find(value => value.valueId === notOkValue)
        ).dimensionId,
        constraint: newConstraints.find(
          constraint => constraint.valueId === notOkValue
        )
      }));
      // TODO: snygga till det här?
      const okSelectedValues = selectedValues.filter(selectedValue => {
        const foundNotOkValue = notOkValues.find(
          notOkValue => notOkValue === selectedValue
        );
        if (foundNotOkValue) {
          return false;
        }
        return true;
      });
      const correctedSelectedValues = okSelectedValues.slice();
      notOkValues.forEach(notOkValue => {
        const dimensionForNotOkValue = this.state.dimensions?.dimensions.find(dimension =>
          dimension.values.find(value => value.valueId === notOkValue)
        );
        // TODO: snygga till det här?
        const firstOkValueFoundInDimension = dimensionForNotOkValue.values.find(
          value => {
            const foundConstraint = newConstraints.find(
              constraintRule => constraintRule.valueId === value.valueId
            );
            if (foundConstraint) {
              return false;
            }
            return true;
          }
        );
        correctedSelectedValues.push(firstOkValueFoundInDimension.valueId);
      });
      // TODO: fixa nedan...
      this.setConstraints(this.getConstraints(correctedSelectedValues));
      this.setState(
        {
          selectedValues: correctedSelectedValues,
          correctionInformation
        },
        this.getPackageSummary
      );
    } else {
      // TODO: fixa nedan...
      this.setConstraints(newConstraints);
      this.setState(
        {
          selectedValues,
          correctionInformation: [
            {
              dimensionId: null,
              constraint: null
            }
          ]
        },
        this.getPackageSummary
      );
    }
  }

  render() {
    if (this.state.generalError) {
      return (
        <div className="lfc-general-error">
          {this.props.messages.generalError}
        </div>
      );
    }

    if (!this.state.dimensions?.dimensions || !this.state.constraints) {
      return this.props.loader || <div className="lfc-loader" />;
    }

    return (
      <Configurator
        language={this.state.language}
        messages={this.props.messages}
        dimensions={this.getSelectableValues(this.state.dimensions?.dimensions, this.state.constraints)}
        dimsHiddenFromMarkets={this.props.dimsHiddenFromMarkets}
        getDimensionName={this.getDimensionName}
        getValueCode={this.getValueCode}
        getValueName={this.getValueName}
        selectedValues={this.state.selectedValues}
        correctionInformation={this.state.correctionInformation}
        onChange={this.checkSelectedValues}
        handleHandingChange={this.props.handleHandingChange}
        renderDimensionDescriptions={this.props.renderDimensionDescriptions}
        publishLevel={this.state.dimensions?.publishLevel}
      />
    );
  }
}

LfcCore.propTypes = {
  context: PropTypes.string.isRequired,
  language: PropTypes.oneOf(["sv", "no", "fi", "en"]).isRequired,
  messages: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  onError: PropTypes.func.isRequired,
  defaultValues: PropTypes.arrayOf(PropTypes.number),
  environment: PropTypes.string,
  lfcMode: PropTypes.string,
  priceHelper: PropTypes.func,
  pricingInfo: PropTypes.string,
  renderDimensionDescriptions: PropTypes.bool,
  updateInProgress: PropTypes.func,
  handleHandingChange: PropTypes.func,
}

const mapStateToProps = (state) => ({

});

const mapDispatchToProps = {
  setDimensionsWithSelectableValues
};

export default connect(mapStateToProps, mapDispatchToProps)(LfcCore);
